import { render } from "./BaseNotification.vue?vue&type=template&id=f9b9ad90&ts=true"
import script from "./BaseNotification.vue?vue&type=script&lang=ts"
export * from "./BaseNotification.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__